import { render } from "./PercentageBar.vue?vue&type=template&id=77b98408&scoped=true"
import script from "./PercentageBar.vue?vue&type=script&lang=js"
export * from "./PercentageBar.vue?vue&type=script&lang=js"

import "./PercentageBar.vue?vue&type=style&index=0&id=77b98408&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b98408"]])

export default __exports__